import React, { createContext, ReactNode } from "react";

import { useWindowSize, BREAK_POINT } from "@myrealtrip/design-system";

import { checkMobileUserAgent } from "@func";

interface PropsType {
  children: ReactNode;
}

export const DetermineMobileContext = createContext(false);

export function DetermineMobileProiver({ children }: PropsType) {
  const [windowSizeWidth] = useWindowSize();
  const isMobile =
    windowSizeWidth < BREAK_POINT.MOBILE || checkMobileUserAgent();

  return (
    <DetermineMobileContext.Provider value={isMobile}>
      {children}
    </DetermineMobileContext.Provider>
  );
}
